import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import DokuParserJS from './docuparser'
import CodeEditor from '@uiw/react-textarea-code-editor';
import Chip from "@mui/joy/Chip";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import Card from "@mui/joy/Card";
import Box from "@mui/joy/Box";
import BaseApi from "../../utils/BaseApi";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import SaveIcon from '@mui/icons-material/Save';


class EditorTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            rawContent: null,
            saved: true
        };
    }

    async componentDidMount(){
        await this.parseCode(this.props.wikiPage.content, true);
    }

    async parseCode(code, saved){
        const baseUrl = `${process.env.REACT_APP_API_HOST}/api/v2/`;
        const parser = new DokuParserJS({
            currentNamespace: 'wiki', // Current namespace for link resolution
            interwikiMap: {
                wp: 'https://en.wikipedia.org/wiki/',
                doku: 'https://www.dokuwiki.org/'
            },
            mediaBasePath: `${baseUrl}wiki_page/media/?path=`, // Base path for media files (local mode)
            pagesBasePath: '/data/pages/', // Base path for pages (local mode)
            useTxtExtension: true, // Append .txt to internal links
            useEmoji: true, // Use Unicode emojis (default: true)
            htmlok: true, // Enable HTML embedding
            typography: true, // Enable typography conversions
            toc: true // Generate TOC for >3 headings (default: false)
        });
        this.setState(
            {
                rawContent: code,
                content: parser.parse(code),
                saved: saved,
            }
        )
    }

    async save() {
        const url = `wiki_page/${this.props.wikiPage.id}/`;
        const api = new BaseApi();
        await api.patch(
            url,
            {
                content: this.state.rawContent,
            }
        );
        this.setState({
            saved: true,
        })
        await this.props.callBack();
    }

    render() {
        if (!this.state.rawContent || !this.state.content) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={1}
                direction={'row'}
                sx={{
                    height: '100%'
                }}
            >
                <Card
                    sx={{
                        width: '50%',
                        height: '100%',
                        overflow: 'auto',
                    }}
                >
                    {
                        this.state.saved ?
                            <Chip
                                color={'success'}
                                sx={{
                                    mr: 1
                                }}
                                startDecorator={<SaveIcon fontSize={'small'}/>}
                            >
                                Сохранен
                            </Chip> :
                            <CommonCallBackButton
                                callBack={this.save.bind(this)}
                                icon={SaveIcon}
                                label={'Сохранить'}
                                color={'success'}
                                variant={'solid'}
                            />
                    }
                    <Box
                        sx={{
                            height: '100%',
                            overflow: 'auto',
                        }}
                    >
                        <CodeEditor
                            data-color-mode={() => (localStorage.getItem("joy-mode"))}
                            value={this.state.rawContent}
                            language="js"
                            placeholder="Please enter code."
                            onChange={(evn) => {
                                this.parseCode(evn.target.value, false)
                            }}
                            padding={0}
                            style={{
                                fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                            }}
                        />
                    </Box>

                </Card>
                <Card
                    sx={{
                        width: '50%',
                        overflowY: 'scroll',
                    }}
                >
                    <div
                        dangerouslySetInnerHTML={{__html: this.state.content}}
                    />
                </Card>
            </Stack>
        )
    }
}

export default EditorTab;



